import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ScheduleTriggerHistoryFormComponent } from './scheduletriggerhistory-form/scheduletriggerhistory-form.component';
import { ScheduleTriggerHistoryComponent } from './scheduletriggerhistory.component';
import { ScheduleTriggerHistoryRoutes } from './scheduletriggerhistory.routing';

export function declaration() {
    return [ScheduleTriggerHistoryComponent, ScheduleTriggerHistoryFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ScheduleTriggerHistoryModule {
}

@NgModule({
    imports: [ScheduleTriggerHistoryModule, ScheduleTriggerHistoryRoutes],
    exports: [ScheduleTriggerHistoryModule]
})
export class ScheduleTriggerHistoryWithRouteModule {
}
